import { render, staticRenderFns } from "./TutorialSettings.vue?vue&type=template&id=493a17a3"
import script from "./TutorialSettings.vue?vue&type=script&lang=js"
export * from "./TutorialSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports